import {Lesson, newCourse} from './course'
import mAxios from './m-axios'

export interface Record {
  course: Lesson
  user_id: string
  course_id: number
  created_at: string
}

export const initRecord: Record = {
  course: newCourse(),
  course_id: 0,
  user_id: '',
  created_at: '',
}

export const addRecord = (record: Record) => {
  return mAxios({
    method: 'post',
    url: '/api/record',
    data: record,
  }).then(res => res.data)
}

export const getRecord = (user_id: string) => {
  return mAxios({
    method: 'get',
    url: '/api/record',
    params: {user_id: user_id},
  }).then(res => res.data)
}
